import { Content as AntContent } from "antd/es/layout/layout";
import React, { useEffect, useState } from "react";
import locale from "antd/lib/locale/pl_PL";
import styled from "styled-components";
import { useQuery } from "react-query";
import { getServicesCalendarOrders } from "../../../service";
import {
  Badge,
  Calendar as ANTCalendar,
  CalendarProps,
  ConfigProvider,
  Modal,
  Row,
  Spin,
} from "antd";
import dayjs, { Dayjs } from "dayjs";
import { ModalTaskRow } from "../modal-task-row/ModalTaskRow";
import { CreateReservationModal } from "../create-reservation-modal/CreateReservationModal";
import { useBranchContext } from "../../../contexts/branch-context";
import { colors } from "../../../styles/theme";
dayjs.locale("pl");

export const Calendar = styled(ANTCalendar)`
  .ant-picker-calendar-header {
    justify-content: flex-start;
    padding: 5px 5px;
  }
  .ant-picker-calendar-date-content {
    height: 114px !important;
  }
  .ant-picker-calendar-mode-switch {
    display: none;
  }
  .events {
    padding: 0;
    margin: 0;
  }
  && .ant-modal-body {
    margin-top: 40px !important;
  }
`;

export const Content = styled(AntContent)`
  padding: 8px;
  min-height: 100%;
  max-height: 100%;
  height: 100%;
  margin: 0;
`;

export const ReservationCalendarNew: React.FC<any> = ({
  setOpen,
  setReservationId,
  createReservationOpen,
  setCreateReservationOpen,
}) => {
  const { currentBranch } = useBranchContext();

  const [visibleTimeStartDelay, setVisibleTimeStartDelay] = useState("");
  const [visibleTimeEndDelay, setVisibleTimeEndDelay] = useState("");

  const [taskList, setTaskList] = useState<any>([]);

  const { isLoading } = useQuery<any, Error>(
    [
      "/service-orders-calendar",
      visibleTimeStartDelay,
      visibleTimeEndDelay,
      currentBranch?.id,
    ],
    () =>
      getServicesCalendarOrders(
        currentBranch?.id,
        visibleTimeStartDelay,
        visibleTimeEndDelay
      ),
    {
      enabled:
        visibleTimeStartDelay !== null &&
        visibleTimeEndDelay !== null &&
        visibleTimeStartDelay !== "" &&
        visibleTimeEndDelay !== "" &&
        !!currentBranch,
      onSuccess(data) {
        setTaskList(data);
      },
      refetchInterval: 10000,
      refetchIntervalInBackground: true,
    }
  );

  const getListData = (value: Dayjs) => {
    return taskList
      .filter((e: any) => {
        return (
          value.format("YYYY-MM-DD") ===
          dayjs.utc(e.startTime).format("YYYY-MM-DD")
        );
      })
      .sort((a: any, b: any) => {
        return (
          dayjs(a.startTime).valueOf() -
          dayjs(b.startTime).valueOf()
        );
      })
      .map((e: any) => {
        return {
          status: e.status,
          content: `${dayjs.utc(e.startTime).format("HH:mm")} - ${e.details?.cart?.[0]?.cart_positoin?.meal_name
            }`,
        };
      });
  };

  const dateCellRender = (value: Dayjs) => {
    const listData = getListData(value);
    return (
      <ul className="events">
        {listData.map((item: any) => (
          <li key={item.content}>
            <Badge
              color={
                item.status === "ACCEPTED"
                  ? "var(--color-success)"
                  : item.status === "REJECTED"
                    ? "var(--color-text-secondary)"
                    : "var(--color-error)"
              }
              text={item.content}
            />
          </li>
        ))}
      </ul>
    );
  };

  const cellRender: CalendarProps<Dayjs>["cellRender"] = (current, info) => {
    if (info.type === "date") return dateCellRender(current);
    return info.originNode;
  };

  const getFirstAndLastDayOfMonth = (monthYear: string) => {
    const [month, year] = monthYear.split("-").map(Number);

    const firstDay = dayjs.utc(`${year}-${month}-01`);

    const lastDay = firstDay.endOf("month");

    const formatDate = (date: any) => date.format("YYYY-MM-DD");

    return {
      first_calendar_day: formatDate(firstDay),
      last_calendar_day: formatDate(lastDay),
    };
  };

  const [, setDataObject] = useState<any>(null);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [selectedDate, setSelectedDate] = useState<any>(null);
  const [value, setValue] = useState<any>(null);

  const handleOk2 = () => {
    setIsModalOpen2(false);
  };

  const handleCancel2 = () => {
    setIsModalOpen2(false);
  };

  useEffect(() => {
    setValue(dayjs.utc());
  }, []);

  useEffect(() => {
    if (value) {
      const firstDayOfMonth = dayjs
        .utc(value)
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastDayOfMonth = dayjs
        .utc(value)
        .endOf("month")
        .format("YYYY-MM-DD");
      setVisibleTimeStartDelay(firstDayOfMonth);
      setVisibleTimeEndDelay(lastDayOfMonth);
    }
  }, [value]);

  return (
    <>
      <Spin spinning={isLoading} fullscreen />
      <ConfigProvider locale={locale}>
        <Calendar
          onSelect={(e, e2) => {
            const tasks = taskList
              .filter(
                (el: any) =>
                  e?.format("YYYY-MM-DD") ===
                  dayjs.utc(el.startTime).format("YYYY-MM-DD")
              )
              .map((el: any) => {
                return (
                  <ModalTaskRow
                    rowData={el}
                    setOpen={setOpen}
                    setReservationId={setReservationId}
                  />
                );
              });
            if (e2.source === "date" && tasks.length > 0) {
              setIsModalOpen2(true);
              setSelectedDate(e);
            }
          }}
          value={value}
          cellRender={cellRender}
          mode="month"
          onChange={(e) => {
            setDataObject(
              getFirstAndLastDayOfMonth(dayjs.utc(e).format("MM-YYYY"))
            );
            setValue(dayjs.utc(e));
          }}
        />
      </ConfigProvider>
      <Modal
        title={selectedDate?.format("YYYY-MM-DD")}
        open={isModalOpen2}
        closable={false}
        cancelButtonProps={{
          style: {
            display: "none",
          },
        }}
        okText="Zamknij"
        onOk={handleOk2}
        onCancel={handleCancel2}
        width={700}
        zIndex={1000}
      >
        <Row
          style={{
            borderBottom: `1px solid ${colors.borderLight}`,
          }}
        >
          <>
            {taskList
              .filter(
                (e: any) =>
                  selectedDate?.format("YYYY-MM-DD") ===
                  dayjs.utc(e.startTime).format("YYYY-MM-DD")
              )
              .sort((a: any, b: any) => {
                return (
                  dayjs(a.startTime).valueOf() -
                  dayjs(b.startTime).valueOf()
                );
              })
              .map((e: any) => {
                return (
                  <ModalTaskRow
                    rowData={e}
                    setOpen={setOpen}
                    setReservationId={setReservationId}
                  />
                );
              })}
          </>
        </Row>
      </Modal>
      <CreateReservationModal
        open={createReservationOpen}
        setOpen={setCreateReservationOpen}
        branchId={currentBranch?.id ?? null}
      />
    </>
  );
};
